import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import ProjectCard from "./ProjectCard";
import projImg1 from "../assets/img/cara3.png";
import projImg2 from "../assets/img/landingpage1.jpg";
import projImg3 from "../assets/img/vehicle1.png";
import projImg4 from "../assets/img/clinic.png";
import projImg5 from "../assets/img/restaurant website.jpg";
import projImg6 from "../assets/img/realstate.jpg";
import TrackVisibility from 'react-on-screen';
import colorSharp2 from '../assets/img/color-sharp2.png';

import 'animate.css';

const Projects = () => {

const frontEndProjects = [
  {
    title: "Cara E-commerce Website",
    description: "E-commerce Website Design & Development",
    imgUrl: projImg1,
    link: "https://cara-from-tariqmehmood.netlify.app/"
  },
  {
    title: "Marketing Website",
    description: "Digital Marketing website",
    imgUrl: projImg2,
    link: "/"
  },
    {
    title: "Vehicle Spare Parts Store",
    description: "Vehicle Website Design & Development",
    imgUrl: projImg3,
    link: "https://chaudhryautostore.com//"
  }
];

const fullstackProjects = [
  {
    title: "Vehicle Spare Parts Store",
    description: "Vehicle Website Design & Development",
    imgUrl: projImg3,
    link: "https://chaudhryautostore.com//"
  },
  {
    title: "Cara E-commerce Website",
    description: "E-commerce Website Design & Development",
    imgUrl: projImg1,
    link: "https://cara-from-tariqmehmood.netlify.app/"
  },
  {
    title: "London Spine Clinic",
    description: "Lnodon Spine Clinic Website Design & Development",
    imgUrl: projImg4,
    link: "https://www.londonspine.com/"
  }
];

const otherProjects = [
  {
    title: "Cara E-commerce Website",
    description: "E-commerce Website Design & Development",
    imgUrl: projImg1,
    link: "https://cara-from-tariqmehmood.netlify.app/"
  },
    {
    title: "Restaurant Website",
    description: "Restaurant Website Design & Development",
    imgUrl: projImg5,
  },
    {
    title: "Realstate Website",
    description: "Realstate Website Design & Development",
    imgUrl: projImg6,
  },
];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>

                <p>The projects I’ve worked on reflect my journey as a developer and showcase my skills in building practical, real-world applications.</p>

                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Frontend Designs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Fullstack Websites</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">More Designs</Nav.Link>
                    </Nav.Item>
                    
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          frontEndProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                             <Row>
                        {
                         fullstackProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">

                         <Row>
                        {
                         otherProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
            <img className='background-image-right' src={colorSharp2} alt='Image' />
    </section>
  )
}
export default Projects;